<template>
<div :class="$style['privacy-policy-detail']" v-loading="loading">
    <h3 :class="$style['privacy-policy-title']">{{privacyPolicyDetail.name}}</h3>
    <div :class="$style['privacy-policy-content']" v-html="privacyPolicyDetail.content">
    </div>
</div>
</template>
<script>
export default {
  props: {
    privacyPolicyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      privacyPolicyDetail: {},
      loading: false
    }
  },
  methods: {
    // 获取隐私条款详情
    getPrivacyPolicyDetail () {
      this.loading = true
      this.$store.dispatch('privacyPolicyDetail', this.privacyPolicyId).then(res => {
        this.loading = false
        this.privacyPolicyDetail = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取隐私条款失败')
      })
    }
  },
  created () {
    this.getPrivacyPolicyDetail()
  }
}
</script>
<style lang="less" module>
.privacy-policy-detail{
    display: flex;
    flex-direction: column;
     ul,li{
        list-style-type:initial!important;
    }
    p,ul,ol{
        margin: inherit;
        margin-block-start:inherit;
        margin-block-end:inherit
    }
    ul{
        padding-inline-start:40px
    }
}
.privacy-policy-title{
    text-align: center
}
.privacy-policy-content{
    display: flex;
    flex: 1;
    line-height: 30px;
    flex-direction: column;
    overflow-y: auto
}
</style>
